import { Component } from '@angular/core';
import { dboflyway_schema_historyEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Flyway _schema _histories') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-dboflyway_schema_history-form',
    templateUrl: './dboflyway_schema_history.form.component.html'
})
export class dboflyway_schema_historyFormComponent extends BaseFormComponent {
    public record!: dboflyway_schema_historyEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

